import axios from "axios";

export const axiosWithAuth = () => {
  const token = localStorage.getItem("token");
  return axios.create({
    baseURL: "https://kh-attendance-be.herokuapp.com/",
    headers: {
      Authorization: token
    }
  });
}
